export default "__VITE_ASSET__2671991c__"